'use client';

import { useScrollSpy } from '@/hooks/useScrollSpy';
import { usePulseStore } from '@/features/pulse';
import { WorkExperienceEntry } from './WorkExperienceEntry';
import {
  clientItems,
  projectItems,
  workItems,
  type Item,
} from '@/data/experience';
import styles from './WorkExperience.module.css';

export const WorkExperience = ({
  onActiveEntityChange,
}: {
  onActiveEntityChange?: (ids: string[] | null) => void;
}) => {
  const setIds = usePulseStore((state) => state.setIds);
  const { activeKey, register } = useScrollSpy<string[]>(
    onActiveEntityChange ?? setIds
  );

  const renderGroup = (label: string, items: Item[]) =>
    items.length > 0 && (
      <section className={styles.group} key={label}>
        <h2 className={styles.label}>{label}</h2>
        <div className={styles.list}>
          {items.map((item) => (
            <WorkExperienceEntry
              key={item.key}
              item={item}
              active={activeKey === item.key}
              ref={register(item.key, item.pulseIds)}
            />
          ))}
        </div>
      </section>
    );

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        {renderGroup('Work experience', workItems)}
        {renderGroup('Client work', clientItems)}
        {renderGroup('Projects', projectItems)}
      </div>
    </section>
  );
};
